<template>
  <div>
    <div>
      <span class="tab-title">About Twilio DEMO Suite</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about-page'
};
</script>

<style scoped lang="scss"></style>
